module.exports = "https://r.nearpod.com/assets/media/image/student_paced-d3a4dafac06304973b4b2ce7fa36d77c.svg";